export default __webpack_public_path__ + "static/media/Silver clouds1.3aea4829.jpg";